export enum KeyBoard {
  Zero = 48,
  Nine = 57,
  Backspace = 8,
  E = 69
}
